<div
  class="container-fluid d-flex flex-column justify-content-center h-100 pb-5"
>
  <div class="row">
    <div
      class="col-10 col-md-6 col-lg-5 col-xl-4 mx-auto"
      style="max-width: 410px"
    >
      <div class="login-bg"></div>
      <div class="border p-5 bg-white rounded">
        <div class="justify-content-center d-flex gap-2 align-items-center">
          <div class="display-6 ms-0 me-2">
            <img
              src="/assets/images/afra-school-colorful.svg"
              alt="لوگوی افرا"
              style="height: 42px"
            />
          </div>
          <div class="display-6 mt-4" routerLink="/">{{ systemNameLabel }}</div>
        </div>
        <form dir="ltr" class="mt-4">
          <div *ngIf="showMobileForm">
            <form [formGroup]="mobileForm">
              <input
                arabicNumber
                type="tel"
                maxlength="11"
                autocomplete="tel"
                class="form-control form-control-lg text-center"
                (keyup)="onMobileNumberInputKeyUp($event)"
                formControlName="mobileNumber"
              />
              <div class="mt-2">
                <small class="text-secondary"
                  >.شماره تلفن همراه را با فرمت _________09 وارد کنید</small
                >
              </div>
              <div
                class="alert alert-warning mt-3"
                style="direction: rtl"
                *ngIf="vpnWarningLabel"
              >
                <span class="fa fa-triangle-exclamation"></span>
                {{ vpnWarningLabel }}
              </div>
              <button
                type="submit"
                class="btn btn-success btn-lg w-100 mt-2"
                [disabled]="!mobileForm.valid"
                (click)="onGetOTPButton()"
              >
                {{ getOTPLabel }}
              </button>
            </form>
            <div class="text-center mt-4">
              <div>
                <a
                  href="https://afraway.org/ws"
                  target="_blank"
                  class="link-success"
                  >راهنمای ثبت نام در کارگاه ها</a
                >
              </div>
              <div class="mt-2">
                شماره تماس:
                <span class="ms-1"
                  ><a class="link-success" href="tel:02191002372"
                    >02191002372</a
                  ></span
                >
                <span class="ms-2">داخلی ۱</span>
              </div>
            </div>
          </div>
          <div *ngIf="showOTPForm">
            <div class="mb-2" style="direction: rtl">
              <small class="text-secondary">{{ OTPBoxLabel }}</small>
            </div>
            <form [formGroup]="otpForm">
              <input
                arabicNumber
                type="tel"
                maxlength="4"
                class="form-control form-control-lg text-center"
                (keyup)="onOTPInputKeyUp($event)"
                formControlName="otpCode"
              />
              <div
                class="alert alert-warning mt-3"
                style="direction: rtl"
                *ngIf="vpnWarningLabel"
              >
                <span class="fa fa-triangle-exclamation"></span>
                {{ vpnWarningLabel }}
              </div>
              <button
                type="button"
                class="btn btn-success btn-lg w-100 mt-3"
                [disabled]="!otpForm.valid"
                (click)="onLogin()"
              >
                {{ loginLabel }}
              </button>
            </form>
            <button
              type="button"
              class="btn btn-light btn-lg w-100 mt-3"
              [disabled]="leftSeconds != null"
              (click)="onGetOTPAgainButton()"
            >
              {{ leftSeconds != null ? leftTimeLabel : getOTPAgainLabel }}
            </button>
            <button
              type="button"
              class="btn btn-light btn-lg w-100 mt-1"
              (click)="onChangeMobileNumberButton()"
            >
              {{ changeMobileLabel }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
